/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type Nav4SidebarSettingsBoardEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const nav4SidebarSettingsBoardEntryPoint: EntryPoint<
	Nav4SidebarSettingsBoardEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<Nav4SidebarSettingsBoardEntryPointComponent>(
		/* webpackChunkName: "nav4-sidebar-board-settings-entry-point" */ './ui/main.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),

	getPreloadProps() {
		return {};
	},
});
